import {getTokenPayload} from "./jwt";
import ControleSessao from "../componentes-padrao/ControleSessao";



export const configureSession = (accessToken: string, refreshToken: string) => {
    accessToken = decodeURIComponent(accessToken)
    const data = getTokenPayload(accessToken)

    ControleSessao.setToken(accessToken);
    ControleSessao.setRefreshToken(refreshToken);

    const tokenClaims = data.authorization?.permissions[0].claims

    ControleSessao.setIdUsuario(Number(tokenClaims.CODIGO_USUARIO[0]));
    ControleSessao.setTipo(tokenClaims.TIPO_USUARIO[0]);
    ControleSessao.setNomeUsuario(tokenClaims.NOME_USUARIO[0]);
    ControleSessao.setTipoEmbarcadora(tokenClaims.TIPO_EMBARCADORA?.[0] || "")
    ControleSessao.setIdEmbarcador(Number(tokenClaims.CODIGO_EMBARCADOR?.[0] || 0))
    ControleSessao.setPossuiVinculoTransportadorExterno(tokenClaims.POSSUI_VINCULO_TRANSPORTADOR_EXTERNO?.[0] === "true")
    ControleSessao.setVisualizaChatMovidesk(tokenClaims.VISUALIZA_CHAT_MOVIDESK?.[0] !== "false")

    if (tokenClaims.CODIGO_CLIENTE) {
        ControleSessao.setIdEmpresa(tokenClaims.CODIGO_CLIENTE[0])
    }
}
